module.exports = __webpack_public_path__ + "img/10to10review.89f33f72.png";